import React, { Component } from 'react';
import { Route } from 'react-router';
import { Col, Grid, Row, Button } from 'react-bootstrap';
import MenuPrincipal from './MenuPrincipal';
import Chat from './Chat';
import MenuFinal from './MenuFinal';
import { LinkContainer } from 'react-router-bootstrap';
import '../css/Global.css';
import { osName, browserName, browserVersion, fullBrowserVersion, osVersion } from 'react-device-detect';

export class Layout extends Component {
    constructor(props) {
        super(props);
        var aceptado = localStorage.getItem("AceptarCookies");
        var guid = localStorage.getItem("Sesion");
        if (aceptado === null || aceptado === undefined) {
            aceptado = false;
        }
        if (guid === null || guid === undefined) {
            guid = ""
        }

        var banderaVisible = true;
        if (window.location.href.toLowerCase().endsWith("universum")) {
            banderaVisible = false;
        }

        this.state = {
            Cookies: !aceptado,
            Guid: guid,
            GuidValidado: false,
            VisibleChat: false,
            MenuVisible: banderaVisible
        }

        this.reportarVisita = this.reportarVisita.bind(this);
        this.getGuid = this.getGuid.bind(this);
        this.unLoad = this.unLoad.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.mostrarMenu = this.mostrarMenu.bind(this);


        this.reportarVisita(window.location.href, "", true);
    }



    handleScroll(event) {

        if (window.pageYOffset > 320) {
            this.setState({ VisibleChat: true });
        } else {
            this.setState({ VisibleChat: false });
        }
    }

    

    getGuid() {
        return this.state.Guid;
    }

    mostrarMenu(mostrar) {
        this.setState({ MenuVisible: mostrar });
        //if (mostrar == false) {
        //    window.location.href = ""
        //    history.push("/Universum")
        //};
    }

    reportarVisita(url, clave, forzar) {
        if (forzar === true || this.state.GuidValidado === true) {
            var xhr = new XMLHttpRequest();
            var principal = this;

            xhr.open("POST", "api/Web/Sesion", true);

            xhr.setRequestHeader("Content-Type", "application/json");

            var sobre = { Guid: this.state.Guid, Url: url, Clave: clave, OS: osName + ' ' + osVersion, Navegador: browserName, Version: fullBrowserVersion };

            xhr.onload = function () {
                if (xhr.status === 200) {
                    try {
                        principal.state.Guid = xhr.responseText;
                        principal.state.GuidValidado = true;
                        localStorage.setItem("Sesion", xhr.responseText);
                    } catch (err) {

                    };
                };

            };

            xhr.send(JSON.stringify(sobre));
        } else {
            setTimeout(() => { this.reportarVisita(url, clave, false) }, 1200)
        }       
    }

    componentDidMount() {
        window.addEventListener("beforeunload", this.unLoad);
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.unLoad);
        window.removeEventListener('scroll', this.handleScroll);
    }

    unLoad() {
        var xhr = new XMLHttpRequest();
        var principal = this;

        xhr.open("POST", "api/Web/CerrarSesion", true);

        xhr.setRequestHeader("Content-Type", "application/json");

        var sobre = { Guid: this.state.Guid };

        xhr.send(JSON.stringify(sobre));
    }


    render() {
        if (window.location.href.toLowerCase().endsWith("godaddy.html")) {
            return ("crqc8kdeq1fmtq932rl0il2pv");
        }
        else {
            return (
                <div>
                    {this.state.MenuVisible

                        ?
                        <MenuPrincipal mostrarMenu={this.mostrarMenu} />
                        :
                        null}
                        {this.state.MenuVisible
                                                ?
                    <Grid fluid className='DivContenido'>
                        <Row>
                            <Col xs={12}>
                                {this.props.children}
                            </Col>
                        </Row>
                        <Row>
                            <MenuFinal />
                            </Row>
                        </Grid>
                            :
                             this.props.children 
                        }
                    {this.state.VisibleChat ?

                        <Chat getGuid={this.getGuid} style={{ display: "block" }} />
                        :
                        <Chat getGuid={this.getGuid} style={{ display: "none" }} />
                    }
                    {this.state.Cookies ?
                        <div className="Cookies">
                            <div>
                                <p>
                                Utilizamos cookies para brindarle la mejor experiencia, si continua navegando se asume que esta de acuerdo con nuestra pol&iacute;tica de privacidad
                                    <Button variant="info" onClick={() => { localStorage.setItem("AceptarCookies", true); this.setState({ Cookies: false }); }}>Aceptar</Button>
                                </p>
                            </div>
                        
                        </div>
                        :
                        <br/>
                        }

                </div>
            );

        }
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/components/Layout.js